import classNames from "classnames";
import { ColumnSizeChangeCallback } from "hooks/useTableCustomizationHelper";
import React from "react";
import { Resizable } from "react-resizable";

import GripIcon from "ac-components/ac-icons/GripIcon";

import "./ACResizableColumnCell.less";

type Props = React.HtmlHTMLAttributes<HTMLTableCellElement> & {
  onResize: ColumnSizeChangeCallback;
  width: number;
  columnKey: React.Key;
  draggable?: boolean;
};

export default function ACResizableColumnCell(props: Props) {
  const { onResize, width, columnKey, draggable, children, ...restProps } =
    props;

  const th = (
    <th
      {...restProps}
      className={classNames(
        draggable ? "ac-draggable-column-th" : "",
        restProps.className,
      )}
    >
      <div
        className={classNames(draggable ? "ac-draggable-column-handle" : "")}
      >
        {draggable ? (
          <span className="grip-icon-holder">
            <GripIcon />
          </span>
        ) : null}
        {children}
      </div>
    </th>
  );
  if (restProps.className?.includes("ac-table-selection-column")) {
    return th;
  }
  return (
    <Resizable
      width={width}
      height={0}
      handle={
        <span
          data-key={columnKey}
          className="ac-resizable-column-handle"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span className="ac-resizable-column-handle-left-stick" />
          <span className="ac-resizable-column-handle-center-stick" />
          <span className="ac-resizable-column-handle-right-stick" />
        </span>
      }
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }}
    >
      {th}
    </Resizable>
  );
}
